<template>
  <van-nav-bar
    title="个人信息核对与采集"
    left-text="返回"
    left-arrow
    @click-left="onClickLeft"
  />
  <van-divider content-position="left">学生信息</van-divider>
  <div class="divcenter">
    <van-row :gutter="10">
      <van-col span="10">学号：{{ ruleForm.datas.student_No }}</van-col>
      <van-col span="14">姓名：{{ ruleForm.datas.student_Name }}</van-col>
    </van-row>
    <van-row :gutter="10">
      <van-col span="10"
        >拼音码：{{ ruleForm.datas.student_Name_Spell }}</van-col
      >
      <van-col span="14"
        >身份证号：{{ ruleForm.datas.student_IDnumber }}</van-col
      >
    </van-row>
    <van-row :gutter="10">
      <van-col span="10">性别： {{ ruleForm.datas.student_Sex }}</van-col>
      <van-col span="14">生日：{{ ruleForm.datas.student_Birthday }}</van-col>
    </van-row>
    <van-row :gutter="10">
      <van-col span="10">年级： {{ ruleForm.datas.student_Grade }}</van-col>
      <van-col span="14">学制：{{ ruleForm.datas.student_Years }}</van-col>
    </van-row>
    <van-row :gutter="10">
      <van-col span="10">民族：{{ ruleForm.datas.student_mz }}</van-col>
      <van-col span="14">政治面貌：{{ ruleForm.datas.student_Zzmm }}</van-col>
    </van-row>
    <van-row :gutter="10">
      <van-col span="10"
        >入学时间： {{ ruleForm.datas.student_Entrance_DateStr }}</van-col
      >
      <van-col span="14"
        >毕业时间：{{ ruleForm.datas.student_Leave_DateStr }}</van-col
      >
    </van-row>
    <van-row :gutter="10">
      <van-col span="10">学生类型：{{ ruleForm.datas.student_Type }}</van-col>
      <van-col span="14">院系：{{ ruleForm.datas.student_Dept }}</van-col>
    </van-row>
    <van-row :gutter="10">
      <van-col span="10">专业： {{ ruleForm.datas.student_Specialty }}</van-col>
      <van-col span="14">班级：{{ ruleForm.datas.student_Class }}</van-col>
    </van-row>
  </div>
  <van-form @submit="onSubmit">
    <van-field
      v-model="ruleForm.datas.student_Mobile"
      name="student_Mobile"
      label="* 手机号："
      placeholder="手机号"
      :rules="[{ required: true, message: '请填写手机号' }]"
    />
    <van-field
      v-model="ruleForm.datas.student_Email"
      name="student_Email"
      label="邮箱："
      placeholder="邮箱"
    />
    <van-field name="checkboxGroup" label="* 生活习性：">
      <template #input>
        <van-checkbox-group v-model="ruleForm.checkList" direction="horizontal">
          <van-checkbox
            shape="square"
            v-for="data in ruleForm.dbbook"
            :name="data.id + ':' + data.name"
            :key="data.serial"
            >{{ data.name }}</van-checkbox
          >
        </van-checkbox-group>
      </template>
    </van-field>
    <van-field
      v-model="ruleForm.datas.student_Memo"
      name="student_Memo"
      label="备注："
      placeholder="备注"
    />
    <van-divider content-position="left">家庭信息</van-divider>

    <van-field
      v-model="ruleForm.datas.student_Home_Parents"
      name="student_Home_Parents"
      label="父/母姓名："
      placeholder="父/母姓名"
    />
    <van-field
      v-model="ruleForm.datas.student_NativePlace"
      name="student_NativePlace"
      label="籍贯："
      placeholder="籍贯"
    />
    <van-field
      v-model="ruleForm.datas.student_Home_Mobile"
      name="student_Home_Mobile"
      label="家庭电话："
      placeholder="家庭电话"
    />
    <van-field
      v-model="ruleForm.datas.student_Home_Code"
      name="student_Home_Code"
      label="邮编："
      placeholder="邮编"
    />
    <van-field
      v-model="ruleForm.datas.student_Home_address"
      name="student_Home_address"
      label="家庭地址："
      placeholder="家庭地址"
    />

    <div style="margin: 16px">
      <van-field type="hidden" name="id" v-model="ruleForm.datas.id" />
      <van-button
        block
        square
        type="primary"
        class="button-cuc"
        native-type="submit"
        >提交信息，下一步，选床</van-button
      >
    </div>
  </van-form>
</template>
<style scoped>
.van-grid-item {
  text-align: left;
  padding-left: 10px;
}
.divcenter {
  margin: auto 10px;
}
.van-row {
 
  border-left: 1px solid #f2f2f2;
}
.van-checkbox {
  padding: 5px;
}
.van-col {
  color: var(--van-grid-item-text-color);
  font-size: var(--van-grid-item-text-font-size);
  line-height: 1.5;
  word-break: break-all;
  border-right: 1px solid #f2f2f2;
  padding: 10px 5px;
  text-align: left;
}
.van-row:last-child{
   border-bottom: 1px solid #f2f2f2;
}
.van-collapse-item__content {
  padding: 0px;
}
.button-cuc {
  color: #fff;
  background: #059490;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-color: #dcdfe6;
  text-align: center;
  font-weight: 500;
  padding: 7px 20px;
  font-size: 14px;
  border-radius: 4px;
}
</style>
<script>
import { Toast } from "vant";
import { Dialog } from "vant";
import { reactive } from "vue";
import { getStudent } from "../../http/api.ts";
import { GetDbook } from "../../http/api.ts";
import { GetStudentXG } from "../../http/api.ts";
import { SaveStudentInfo } from "../../http/api.ts";
import { getTime } from "../../http/api.ts";
import { baseurl } from "../../http/api.ts";
import { ref } from "vue";
import Qs from "qs";
import Route from "../../router/index";
export default {
  setup() {
    let ruleForm = reactive({
      datas: [],
      dbbook: [],
      checkList: [],
    });
    let imgs = ref("");

    let dataFun = async () => {
      await getStudent().then((res) => {
        ruleForm.datas = res.datas;
        ruleForm.datas.student_Photo = baseurl + ruleForm.datas.student_Photo;
      });
      await GetDbook("学生生活习性").then((res) => {
        ruleForm.dbbook = res.datas;
      });
      await GetStudentXG(ruleForm.datas.id).then((res) => {
        const list = [];
        res.datas.forEach((element) => {
          list.push(element.habitsId + ":" + element.habitsName);
        });
        ruleForm.checkList = ref(list);
      });
    };
    dataFun();
    return {
      ruleForm,
      imgs,
    };
  },
  methods: {
    onEdit() {
      Toast("编辑");
    },
    onClickLeft() {
      history.go(-1);
    },
    onSubmit(values) {
      getTime().then((res) => {
        if (!res.datas) {
           Dialog.alert({
                    title: '提示',
                    message: res.msg
                    ,allowHtml:true
                  });
        } else {
          if (this.ruleForm.checkList.length == 0) {
            Toast.fail("带*号的为必填项，不能为空！");
            return false;
          }
          Toast.loading("提交中...");
          values.checkList = this.ruleForm.checkList;
          SaveStudentInfo(Qs.stringify(values)).then((res) => {
            if (res.code == 200) {
              Toast.success('个人信息保存成功！');
              setTimeout(() => {
                Route.push("/m/house?tmsite="+Math.random());
              },1500)
            } else {
              Toast.fail(res.msg);
            }
          });

          Toast.clear();
        }
      });
    },
  },
};
</script>